import type { CurrencyCode, GlycerinService } from '@packages/tracking/src/types/types';
import type { APlusData } from '../types';

export const getAplusDataForTracking = (aPlusData: APlusData | null, currency: CurrencyCode) => {
  if (!aPlusData) {
    return undefined;
  }
  const trackingData: GlycerinService[] = [];

  aPlusData.values().forEach(({ item, selected, value }) => {
    trackingData.push({
      currency,
      displayedPrice: item.price ? Math.round(item.price * 100) : 0,
      serviceType: item.clusterLabel,
      name: item.name || '',
      quantity: value || (selected ? 1 : 0),
      serviceId: item.uuid,
    });
  });

  return trackingData.length > 0 ? trackingData : undefined;
};
